import { useState } from "react";
import { useTranslations } from "next-intl";
import useFlash from "@hooks/use-flash";
import { useDeleteCartItem, useReloadPendingCart } from "@hooks/use-cart";
import { useSizeReferenceDisplay } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import SizeReferenceMention from "@components/core/SizeReferenceMention";
import translateVariantSize from "@utils/translateVariantSize";
import sizeTypes from "@utils/constants/sizeTypes";
import ProductPriceSection from "../Product/Shared/ProductPriceSection";
import CartImageLink from "./CartImageLink";

const CartItem = ({ cartItem, isCartItemRemovable }) => {
  const t = useTranslations("common");

  const sizeReference = useSizeReferenceDisplay();

  const [loading, setLoading] = useState(false);

  const addFlash = useFlash();
  const deleteCartItem = useDeleteCartItem();
  const reloadPendingCart = useReloadPendingCart();

  const { product, size } = cartItem.variant;

  async function removeFromCart(cartItemId) {
    try {
      setLoading(true);
      await deleteCartItem(cartItemId);
    } catch (err) {
      reloadPendingCart();
      addFlash(t("cart_modal.error_on_delete_cart_item"), { variant: "danger" }, true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="d-flex justify-content-start"
      data-testid="cart-item"
    >
      <CartImageLink product={product} />
      <div className="ps-3 py-3">
        <h6 className="mb-1">{product.name}</h6>
        <p className="mb-1 font-size-sm">{product.brand.name}</p>
        <p className="mb-2 font-size-sm">
          {t("variant_size", {
            size: translateVariantSize(size?.type, size?.value, t, sizeReference),
          })}
          {size?.type === sizeTypes.size_fr && <SizeReferenceMention />}
        </p>
        <ProductPriceSection
          product={product}
          className="mb-2"
          hideDiscountPercent
        />

        {isCartItemRemovable && (
          <Button
            variant="link-primary no-underline"
            onClick={() => removeFromCart(cartItem.id)}
            size="sm"
            loading={loading}
          >
            {t("cart_modal.remove")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CartItem;
